import {QuickSelectionItem} from '@hconnect/uikit/src/lib2/components/simpleDatePicker/types'
import moment from 'moment'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

const quickSelectionItemIds = [
  'last30days',
  'last7days',
  'last3days',
  'last24hours',
  'last12hours',
  'last6hours'
] as const

export type QuickSelectionItemId = (typeof quickSelectionItemIds)[number]

export const useQuickSelectionItems = (itemId?: string | null) => {
  const {t} = useTranslation()

  const selectionItems: QuickSelectionItem[] = useMemo(() => {
    const quickSelectionItemTitles: Record<QuickSelectionItemId, string> = {
      last30days: t('timeRanges.last30days'),
      last7days: t('timeRanges.last7days'),
      last3days: t('timeRanges.last3days'),
      last24hours: t('timeRanges.last24hours'),
      last12hours: t('timeRanges.last12hours'),
      last6hours: t('timeRanges.last6hours')
    }

    return quickSelectionItemIds.map((id) => ({
      id,
      title: quickSelectionItemTitles[id],
      dates: getDatesForItem(id)
    }))
  }, [t])

  const selectedItem = useMemo(
    () => selectionItems.find((item) => item.id === itemId),
    [selectionItems, itemId]
  )
  return {selectionItems, selectedItem}
}

export const getDatesForItem = (id: QuickSelectionItemId): [Date, Date] => {
  const now = moment()
  switch (id) {
    case 'last30days':
      return [now.clone().subtract(30, 'days').toDate(), now.toDate()]
    case 'last7days':
      return [now.clone().subtract(7, 'days').toDate(), now.toDate()]
    case 'last3days':
      return [now.clone().subtract(3, 'days').toDate(), now.toDate()]
    case 'last24hours':
      return [now.clone().subtract(24, 'hours').toDate(), now.toDate()]
    case 'last12hours':
      return [now.clone().subtract(12, 'hours').toDate(), now.toDate()]
    case 'last6hours':
      return [now.clone().subtract(6, 'hours').toDate(), now.toDate()]
    default:
      throw new Error(`Unknown quick selection item id: ${id}`)
  }
}
